module.exports = __webpack_public_path__ + "img/FAV_0066.decfc316.jpg";